
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flag/agentic-ai-2026/on/catalog",
      function () {
        return require("private-next-pages/flag/agentic-ai-2026/on/catalog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flag/agentic-ai-2026/on/catalog"])
      });
    }
  